import { FormattedMessage } from '@subaio/components'

import { Button } from './Button'
import { Container } from './Container'

type Props = {
	isDemoData: boolean
	onChange: (isDemoData: boolean) => void
}

export const Tabs = ({ isDemoData, onChange }: Props) => (
	<Container role='tablist' aria-label='Choose data source'>
		<Button
			id='home-your-data-tab'
			type='button'
			role='tab'
			aria-controls='home-data-panel'
			aria-selected={!isDemoData}
			onClick={() => onChange(false)}
		>
			<FormattedMessage id='home.yourData.tab' defaultMessage='Your data' />
		</Button>
		<Button
			id='home-demo-data-tab'
			type='button'
			role='tab'
			aria-controls='home-data-panel'
			aria-selected={isDemoData}
			onClick={() => onChange(true)}
		>
			<FormattedMessage id='home.demoData.tab' defaultMessage='Demo data' />
		</Button>
	</Container>
)
